import {
  Directive,
  Input,
  OnInit,
  ElementRef,
  Inject,
  Optional,
  Self,
  OnChanges,
  SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import {
  NgrxFormControlDirective,
  FormControlValueTypes,
  NGRX_FORM_VIEW_ADAPTER,
  FormGroupState,
  FormControlState
} from 'ngrx-forms';
import { DOCUMENT } from '@angular/common';
import { ActionsSubject } from '@ngrx/store';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';

@Directive({
  selector: '[dxFormArrayControl]'
})
export class DxFormArrayControlDirective<TStateValue extends FormControlValueTypes, TViewValue = TStateValue>
  extends NgrxFormControlDirective<TStateValue, TViewValue> implements OnInit, OnChanges {

  @Input() public dxFormArrayControl: string | null = null;

  @Input()
  public set group(value: FormGroupState<any> | null) {
    this._group = value;
    if (this._initialized && value && this.dxFormArrayControl) {
      this.updateNgrxFormControlState(this.applyControlPath(value, this.dxFormArrayControl));
    }
  }

  private _group: FormGroupState<any> | null = null;

  private _initialized = false;

  constructor(
    el: ElementRef,
    @Optional() @Inject(DOCUMENT) dom: any,
    actionsSubject: ActionsSubject,
    @Self() @Optional() @Inject(NGRX_FORM_VIEW_ADAPTER) viewAdapters: any,
    @Self() @Optional() @Inject(NG_VALUE_ACCESSOR) valueAccessors: any,
    public readonly logger: NGXLogger,
    public readonly view: ViewContainerRef
  ) {
    super(el, dom, actionsSubject, viewAdapters, valueAccessors);
  }

  public ngOnInit(): void {

    if (!this._group) {
      this.logger.error(`[DxFormArrayControlDirective::ngOnInit::${this.dxFormArrayControl}] group input is not set`, this);
      throw new Error(`[DxFormArrayControlDirective::ngOnInit::${this.dxFormArrayControl}] group input is not set`);
    }

    if (!this.dxFormArrayControl) {
      this.logger.error(`[DxFormArrayControlDirective::ngOnInit::${this.dxFormArrayControl}] dxFormControl input is not set`);
      throw new Error(`[DxFormArrayControlDirective::ngOnInit::${this.dxFormArrayControl}] dxFormControl input is not set`);
    }

    this.updateNgrxFormControlState(this.applyControlPath(this._group, this.dxFormArrayControl));

    super.ngOnInit();

    this._initialized = true;

  }

  private updateNgrxFormControlState(state: FormControlState<any>): void {
    this.ngrxFormControlState = state;
    (<any>this.view)._data.componentView.component.ngrxFormControl = state
  }

  private applyControlPath(baseState: FormGroupState<any>, controlPath: string): FormControlState<any> {
    this.logger.trace(`[DxFormArrayControlDirective::ngOnInit::${controlPath}] baseState`, baseState);
    const targetState = controlPath.split('/').reduce((state, controlId) => {

      if (state.controls.hasOwnProperty(controlId)) {
        const newState = state.controls[ controlId ];
        this.logger.trace(`[DxFormArrayControlDirective::ngOnInit::${controlPath}] reduce state`, { controlId, newState });
        return newState;
      }
      this.logger.error(
        `[DxFormArrayControlDirective::ngOnInit::${controlPath}] control path is not valid`,
        { dxFormControl: controlPath, baseState }
      );
      throw new Error(`[DxFormArrayControlDirective::ngOnInit::${controlPath}] control path is not valid`);

    }, baseState);
    this.logger.trace(`[DxFormArrayControlDirective::ngOnInit::${controlPath}] targetState`, targetState);

    return targetState as FormControlState<any>;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes[ 'dxFormArrayControl' ] && changes[ 'dxFormArrayControl' ].previousValue && changes[ 'dxFormArrayControl' ].previousValue !== changes[ 'dxFormArrayControl' ].currentValue) {
      this.logger.error(`[DxFormArrayControlDirective::ngOnInit::${this.dxFormArrayControl}] the dxFormArrayControl input should not change`, changes[ 'dxFormArrayControl' ]);
      throw new Error(`[DxFormArrayControlDirective::ngOnInit::${this.dxFormArrayControl}] the dxFormArrayControl input should not change`);
    }
  }

}
